import { TrashIcon } from '@phosphor-icons/react'

import { Button, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ScenarioCard = ({ title, removeLabel, testId, onRemove, children }) => {
  return (
    <Styles.Container data-testid={testId}>
      <Styles.Header>
        <Text type="allCapsS">{title}</Text>
        <Button variant="text" aria-label={removeLabel} onClick={onRemove}>
          <TrashIcon size={20} />
        </Button>
      </Styles.Header>
      {children}
    </Styles.Container>
  )
}

export default ScenarioCard
